import { initSmoothAnchorLinks } from './ui/smooth_anchor_links'

export { initSmoothAnchorLinks }

export function initInterviewDetail() {
  initSmoothAnchorLinks()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInterviewDetail)
} else {
  initInterviewDetail()
}
